<div class="navblock hidden-print">
  <button  (click)="openCreateModal()" class="btnadd">{{'Add retranslation'|translate}}</button>
</div>
<div class="tablewrap admindrivers">
  <div class="table">
    <table fixedcols="[0, 2]" id="exporttable">
      <tr>
        <th>
          <switch-all-checkbox [items]="objects | groupFilter : filter" />
        </th>
        <th>{{'Name' | translate}}</th>
        <th>{{'Retranslation protocol' | translate}}</th>
        <th>{{'Active' | translate}}</th>
        <th>{{'Objects count' | translate}}</th>
        <th>{{'Retranslation from' | translate}}</th>
        <th>{{'Retranslation till' | translate}}</th>
        <th>&nbsp;</th>
      </tr>
      <tr *ngFor="let retranslation of objects | groupFilter : filter">
        <td>
          <input type="checkbox" [(ngModel)]="retranslation.IsChecked"/>
        </td>
        <td>{{retranslation.Name}}</td>
        <td>{{Protocol[retranslation.Protocol]}}</td>
        <td>{{RetranslationStatus[retranslation.Status] | translate}}</td>
        <td>{{retranslation.Objects.length}}</td>
        <td>{{ retranslation.From ? formatDate(retranslation.From) : '' }}</td>
        <td>{{ retranslation.Till ? formatDate(retranslation.Till) : '' }}</td>
        <td class="hidden-print">
          <button class="btn_img btn_edit"  title="{{'Edit'|translate}}" (click)="openEditModal(retranslation)"></button>
          <button class="btn_img btn_trush " (click)="deleteObject(retranslation.Id)" title="{{'Delete'|translate}}"></button>
        </td>
      </tr>
    </table>
  </div>
</div>
<app-footer-component (onDeleteSelected)="deleteSelected()" [items]="objects | groupFilter : filter"></app-footer-component>

<template #mgmtDialog></template>
